import { render, staticRenderFns } from "./IconImage.vue?vue&type=template&id=00b1e556&scoped=true"
import script from "./IconImage.vue?vue&type=script&lang=js"
export * from "./IconImage.vue?vue&type=script&lang=js"
import style0 from "./IconImage.vue?vue&type=style&index=0&id=00b1e556&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b1e556",
  null
  
)

export default component.exports